import Viewport from '@vaersaagod/tools/Viewport';
import { getScrollbarWidth } from '@vaersaagod/tools/utils';
import Config from '@vaersaagod/tools/Config';
import $ from '@vaersaagod/tools/Dom';
import Dispatch from '@vaersaagod/tools/Dispatch';

import * as events from './events';

let scrollLocked = false;
let scrollTopBeforeLock = Viewport.scrollTop;
let scrollLockTarget = null;
const lockItemsMobile = ['[data-header-bar]'];
// const lockItemsDesktop = ['[data-header-content-large]'];

export const lockScroll = target => {
    if (scrollLocked) {
        console.log('lockScroll: already locked');
        return;
    }
    console.log('lockScroll: ', target);
    Dispatch.emit(events.BEFORE_SCROLL_LOCKED);

    const $body = $('body');
    const scrollbarWidth = Config.get('scrollbarWidth') || getScrollbarWidth();
    const bgColor = $body.css('backgroundColor');

    scrollLocked = true;
    scrollTopBeforeLock = Viewport.scrollTop;

    $body
        .css({
            overflow: 'hidden',
            position: 'absolute',
            width: '100%',
            height: `calc(100vh + ${scrollTopBeforeLock}px)`,
            top: `-${scrollTopBeforeLock}px`,
            left: 0
        });

    $('html')
        .css({
            position: 'absolute',
            width: '100%',
            height: `calc(100vh + ${scrollTopBeforeLock}px)`,
            left: 0,
            top: 0,
            overflow: 'hidden',
            borderRight: scrollbarWidth ? `${getScrollbarWidth()}px solid ${bgColor}` : ''
        });

    if (target) {
        scrollLockTarget = target;
        const $target = $(scrollLockTarget);

        let targetScrollY = null;
        const isTargetTotallyScrolled = () => {
            return scrollLockTarget.scrollHeight - scrollLockTarget.scrollTop <= scrollLockTarget.clientHeight;
        };

        const disableRubberBand = e => {
            const clientY = e.targetTouches[0].clientY - targetScrollY;
            if ((scrollLockTarget.scrollTop === 0 && clientY > 0) || (isTargetTotallyScrolled() && clientY < 0)) {
                e.preventDefault();
            }
        };

        $target.on('touchstart', e => {
            if (e.targetTouches.length === 1) {
                targetScrollY = e.targetTouches[0].clientY;
            }
        });

        $target.on('touchmove', e => {
            e.stopPropagation();
            if (e.targetTouches.length === 1) {
                disableRubberBand(e);
            }
        });
    }

    if (Viewport.breakpoint.size < 750) {
        $(lockItemsMobile).each(item => {
            $(item).css({
                width: scrollbarWidth ? `calc(100% - ${scrollbarWidth}px)` : '100%'
            });
        });
    } else {
        // $(lockItemsDesktop).each(item => {
        //     $(item).css({
        //         width: scrollbarWidth ? `calc(100% - ${scrollbarWidth}px)` : '100%'
        //     });
        // });
    }


    window.scrollTo(0, 0);

    Dispatch.emit(events.SCROLL_LOCKED);
};

export const releaseScroll = () => {
    if (!scrollLocked) {
        console.log('releaseScroll: already released');
        return;
    }

    console.log('releaseScroll');

    $(lockItemsMobile).each(item => {
        $(item).css({
            width: ''
        });
    });
    //
    // $(lockItemsDesktop).each(item => {
    //     $(item).css({
    //         width: ''
    //     });
    // });

    Dispatch.emit(events.BEFORE_SCROLL_RELEASED);

    scrollLocked = false;

    $('body')
        .css({
            overflow: '',
            position: '',
            width: '',
            height: '',
            top: '',
            left: ''
        });

    $('html')
        .css({
            position: '',
            width: '',
            height: '',
            overflow: '',
            left: '',
            top: '',
            borderRight: ''
        });

    if (scrollLockTarget) {
        $(scrollLockTarget).off('touchstart').off('touchmove');
        scrollLockTarget = null;
    }

    window.scrollTo(0, scrollTopBeforeLock);

    Dispatch.emit(events.SCROLL_RELEASED);

};



// WEBPACK FOOTER //
// ./src/js/lib/helpers.js